"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessSettings = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="container-fluid">
    <div class="user-group-list-page">
      <crud-table title="${'route.settings.access'.t()}" addText="${'route.settings.accessAdd'.t()}" resource="settings_access" searchPlaceholder="${'access.list.searchPlaceholder'.t()}"
        listEndpoint="acl-policy.list" deleteEndpoint="acl-policy.delete"
        editRoute="/settings/access/edit/:id" addRoute="/settings/access/add" :columns="${x => x.tableColumns}">
      </crud-table>
    </div>
  </div>
</template>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let AccessSettings = class AccessSettings extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            {
                key: 'userGroup',
                header: 'access.user_group'.t(),
                formatter: (userGroup) => {
                    return userGroup ? userGroup.name : '-';
                }
            },
            {
                key: 'acl',
                header: 'access.policies'.t(),
                formatter: (acl) => {
                    if (!acl || typeof acl !== 'object')
                        return '-';
                    console.log({ acl });
                    return Object.keys(acl).map(resourceKey => {
                        const actions = acl[resourceKey];
                        if (!Array.isArray(actions))
                            return '';
                        const actionBadges = actions.map(actionKey => {
                            const badgeColor = actionKey === 'read' ? 'success' :
                                actionKey === 'write' ? 'primary' : 'danger';
                            return `<span class="badge badge-${badgeColor} mr-1">${`acl_action.${actionKey}`.t()}</span>`;
                        }).join('');
                        return `<p class="mb-1"><strong>${`acl_resource.${resourceKey}`.t()}:</strong> ${actionBadges}</p>`;
                    }).join('');
                }
            },
            {
                key: 'active',
                header: 'access.active'.t(),
                formatter: (active) => {
                    const status = active ? 'access.status.active'.t() : 'access.status.inactive'.t();
                    const badgeClass = active ? 'success' : 'danger';
                    return `<span class="badge badge-${badgeClass}">${status}</span>`;
                }
            }
        ];
    }
};
exports.AccessSettings = AccessSettings;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccessSettings.prototype, "tableColumns", void 0);
exports.AccessSettings = AccessSettings = __decorate([
    (0, client_1.RWSView)('settings-access', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], AccessSettings);
AccessSettings.defineComponent();
